const Close = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.586 0L9 7.586L1.414 0L0 1.414L7.586 9L0 16.586L1.414 18L9 10.414L16.586 18L18 16.586L10.414 9L18 1.414L16.586 0Z"
        fill="#1A61A8"
      />
    </svg>
  )
}

export default Close
